import { render, staticRenderFns } from "./Pois.vue?vue&type=template&id=10e38eb8&scoped=true"
import script from "./Pois.vue?vue&type=script&lang=js"
export * from "./Pois.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e38eb8",
  null
  
)

export default component.exports